import { useHotelQuestionnaireSteps } from '../../../../hooks';
import {  Question } from '../../../../types/api';
import { shouldShowUploadSection as utilsShouldShowUploadSection } from '../utils/questionFieldUtils';
import { shouldUploadSource } from '../../../../utils/sourcesUtils';

/**
 * Custom hook for QuestionField component logic
 */
export const useQuestionField = (question: Question, value: any) => {
  const { stepsData } = useHotelQuestionnaireSteps();
  const currentStepKey = stepsData?.currentStepKey;
  // console.log('Current Step Key in useQuestionField::', currentStepKey);
  const hotelId = stepsData?.hotelId;

  const handleFileChange = (onChange: (value: any) => void) => 
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const files = event.target.files;
      if (files) {
        const fileNames = Array.from(files).map(file => file.name);
        onChange(fileNames);
      }
    };

  const shouldShowUploadSection = () => {
    // If in readonly mode (no hotelId) and has attachment, always show
    if (!hotelId && question.hasAttachment) {
      return true;
    }
    if (currentStepKey === 'sources') {
      return true;
    }
    // Otherwise use normal logic
    return utilsShouldShowUploadSection(question, value);
  };

  const isUploadDisabled = () => {
    if (currentStepKey === 'sources') {
      return !shouldUploadSource(question);
    }
    return false;
  };

  const shouldShowApproveSection = () => {
    return currentStepKey === 'sources';
  }
  return {
    currentStepKey,
    handleFileChange,
    shouldShowUploadSection,
    shouldShowApproveSection,
    isUploadDisabled,
  };
};